import { HomeIcon } from '@synoptic/ui-kit/icons/react/home.js';
import { paths } from '@/routes-utils/paths';
import { MenuActionLink } from './menu-action-link';

export const HomeMenuAction = () => {
  return <MenuActionLink icon={<HomeIcon />} to={paths.home} label={'Home'} />;
};
